module.exports = __webpack_public_path__ + "img/deadline-icon.34ba562f.png";